import axios, { AxiosRequestConfig } from "axios";
import { AnoModelo, VeiculoResponse } from "../types/veiculo";

export const buscarVeiculoPorChassi = async (
  token: string,
  chassi: string
): Promise<VeiculoResponse> => {
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  };

  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/busca/alteracao/${chassi}`;
  const response = await axios.get(url, config);
  return response.data;
};

export const atualizarModeloVeiculo = async (
  token: string,
  idVeiculo: number,
  idModelo: number
): Promise<void> => {
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  };

  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/update/modelo/${idVeiculo}`;
  await axios.put(url, { id_modelo: idModelo }, config);
};

export const buscarAnosModelo = async (token: string): Promise<AnoModelo[]> => {
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  };

  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/ano/modelo`;
  const response = await axios.get(url, config);
  return response.data; 
};

export const atualizarAnoModeloVeiculo = async (
  token: string,
  idVeiculo: number,
  idAnoModelo: number
): Promise<void> => {
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  };

  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/${idVeiculo}`;
  await axios.put(url, { id_ano_modelo: idAnoModelo }, config);
};

export const deletarVeiculo = async (
  token: string,
  idVeiculo: number
): Promise<void> => {
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  };

  const url = `${process.env.REACT_APP_API_DOMAIN}/atendimento/veiculo/${idVeiculo}`;
  await axios.delete(url, config);
};